import { ApiProperty } from "@nestjs/swagger";

export class StockSoRequest {
    @ApiProperty()
    saleOrderId: number;
}
